import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate, currencyFormat } from 'utilities/common';

import PODViewer from 'ui/components/imageViewer';

export const DetailReceivable = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="billing">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Penagihan
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <div className="row">
              <div className="col-6">
                <ListHorizontal
                  title="Client"
                  content={
                    data?.customer?.company_name !== ''
                      ? `${data?.customer?.company_name} - ${data?.customer?.name}`
                      : data?.customer?.name
                  }
                />
                {data?.shipment_code && (
                  <ListHorizontal title="Resi" content={data?.shipment_code} />
                )}
                <ListHorizontal
                  title="Project"
                  content={`${data?.project?.name} (${data?.project?.type} - ${data?.project?.invoice_method})`}
                />
                <ListHorizontal
                  title="Project Periode"
                  content={formatDate(data?.periode_project, 'YYYYMM')}
                />
                <ListHorizontal
                  title="No. Referensi"
                  content={data?.ref_code || '-'}
                />
                <ListHorizontal
                  title="Alamat Penagihan"
                  content={data?.billing_address}
                />
                <ListHorizontal
                  title="Emails"
                  content={data?.emails?.map((e) => (
                    <div className="flex-column">{e}</div>
                  ))}
                />
              </div>
              <div className="col-6">
                <ListHorizontal
                  title="Tanggal Penagihan"
                  content={formatDate(data?.schedule_at, 'DD/MM/YYYY')}
                />

                {data?.term_of_payment > 0 && (
                  <ListHorizontal
                    title="Ketentuan Pembayaran"
                    content={`${data?.term_of_payment} Hari`}
                  />
                )}

                <ListHorizontal
                  title="Jatuh Tempo"
                  content={formatDate(data?.due_at, 'DD/MM/YYYY')}
                />

                <ListHorizontal
                  title="Kirim Email"
                  content={data?.is_send_email ? 'Sudah' : 'Belum'}
                />

                <ListHorizontal
                  title="Dibuat Oleh"
                  content={data?.created_by}
                />
                <ListHorizontal
                  title="Dibuat Tanggal"
                  content={formatDate(data?.created_at)}
                />
                {data.updated_by && (
                  <>
                    <ListHorizontal
                      title="Dipebaharui Oleh"
                      content={data?.updated_by}
                    />
                    <ListHorizontal
                      title="Dipebaharui Tanggal"
                      content={formatDate(data?.updated_at)}
                    />
                  </>
                )}

              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export const DetailPayment = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="payment">
      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <div className="mt-3">
            <ListHorizontal
              title="Subtotal"
              content={currencyFormat(data?.subtotal_price, 'IDR')}
              colContent="col-7 text-uppercase text-end"
            />
            {data?.subtotal_discount > 0 && (
              <ListHorizontal
                title="Diskon Perbaris"
                content={currencyFormat(data?.subtotal_discount, 'IDR')}
                colContent="col-7 text-uppercase text-end"
              />
            )}
            {data?.discount > 0 && (
              <ListHorizontal
                title="Diskon"
                content={currencyFormat(data?.discount, 'IDR')}
                colContent="col-7 text-uppercase text-end"
              />
            )}
            {data?.taxes &&
              data?.taxes.map((e, i) => (
                <ListHorizontal
                  title={e?.text}
                  content={currencyFormat(e?.nominal, 'IDR')}
                  colContent="col-7 text-uppercase text-end"
                />
              ))}
            {data?.pph_percentage > 0 && (
              <ListHorizontal
                className="border-top"
                title={`PPh ${data?.pph_percentage}`}
                content={`(${currencyFormat(data?.pph_nominal, 'IDR')})`}
                colContent="col-7 text-uppercase text-end"
              />
            )}
            {data?.down_payment > 0 && (
              <ListHorizontal
                title="Pemotongan"
                content={`(${currencyFormat(data?.down_payment, 'IDR')})`}
                colContent="col-7 text-uppercase text-end"
              />
            )}
            <ListHorizontal
              title="Total Tagihan"
              content={currencyFormat(data?.total_charges, 'IDR')}
              colContent="col-7 text-uppercase text-end"
            />

            {data?.document_status !== 'new' && (
              <>
                <ListHorizontal
                  title="Total Pembayaran"
                  content={currencyFormat(data?.total_paid, 'IDR')}
                  colContent="col-7 text-uppercase text-end"
                />
                <ListHorizontal
                  title="Sisa Tagihan"
                  content={currencyFormat(
                    data?.total_charges - data?.total_paid,
                    'IDR'
                  )}
                  colContent="col-7 text-uppercase text-end"
                />
              </>
            )}
            {data?.additional_charges > 0 && (
              <ListHorizontal
                title="Admin/Return"
                content={currencyFormat(data?.additional_charges, 'IDR')}
                colContent="col-7 text-uppercase text-end"
              />
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export const DetailNote = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="billing">
      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <div className="mt-3">
            <ListHorizontal title="Catatan" className="border-0 " />
            <cite className="border-0 fs-8 tx-white-pre" >{data?.note || '-'}</cite>
            <hr />
            {data?.attachments && (
              <div className="row flex-wrap list-item m-0 align-items-center py-1 mb-1">
                <div className="p-0 fs-8">Attachments</div>
                <PODViewer
                  items={data?.attachments}
                  imgStyle={{ height: 60, width: 60, objectFit: 'cover' }}
                  imgClass="img-hover img-responsive rounded-3"
                  wrapperClass="row mt-2 w-100"
                  imgWrapperClass="col-6 p-2 border-1 border justify-content-center align-items-center d-flex flex-column"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
